<template>
  <div
    :style="{
      backgroundImage: `url(${require('@/assets/images/member-bg.png')})`
    }"
    class="userinfo"
  >
    <div
      :class="{'webkit-drag': devicePixelRatio <= 1.25}"
      class=" section"
    >
      <div class="logo position-div">
        <i class="sprite-icon sprite-icon-home-logo" />PDF-会员中心
      </div>
      <!-- 头像&勋章 -->
      <div
        @click="changeUserInfo"
        class="avatar-wrap"
      >
        <div
          v-if="(!loginStatus) || !avatar"
          class="not-login-avatar sprite-icon sprite-icon-avatar position-div webkit-no-drag"
        />
        <img
          v-else
          :src="avatar"
          :class="{ pointer: !loginStatus }"
          class="avatar webkit-no-drag"
        >
        <span
          v-if="isMember || isPdfMember || isPdfLifeMember"
          :class="badgeClass"
          class="user-icon position-div"
        />
      </div>

      <!-- 未登录 -->
      <div v-if="!loginStatus">
        <span class="tit1 position-div">登录获取最新优惠信息！</span>
        <a
          @click.prevent="login(2)"
          class="btn_login nondraggable position-div webkit-no-drag"
        >立即登录</a>
      </div>

      <!-- 已登录 -->
      <div v-else>
        <div
          :class="{ 'is-member': isMember }"
          class="user-name-w"
        >
          <span class="user-name">{{ userInfo ? userInfo.nickname : '' }}</span>
          <a
            @click.prevent="logout(2)"
            class="btn webkit-no-drag"
          >退出</a>
          <a
            v-if="isMember && device_list.length > 1"
            @click.prevent="toDeviceAdmin"
            class="btn webkit-no-drag"
          >电脑管理</a>
        </div>
        <!-- 钻石会员 -->
        <div
          v-if="is_diamond"
          class="tit4"
        >
          您已升级为钻石会员，不限时享受高级特权！
        </div>
        <!-- 普通会员 -->
        <div
          v-else-if="isMember"
          class="tit4"
        >
          <!-- 非续费会员 -->
          <div
            v-if="!is_continuous"
            class="not-continuous-w"
          >
            <span>{{ userInfo.vip_ex_date | dateFilter }}到期</span>
            <!-- <a
              class="renew_btn nondraggable webkit-no-drag"
              @click="showPay(1)"
            >续费VIP</a> -->
          </div>
          <div v-else>
            您已成为会员，享受会员专属特权！
          </div>
        </div>
        <!-- pdf 终身会员 -->
        <div
          v-else-if="isPdfLifeMember"
          class="tit4"
        >
          <div class="not-continuous-w">
            <span>PDF会员  终身有效</span>
          </div>
        </div>
        <!-- pdf会员 -->
        <div
          v-else-if="isPdfMember"
          class="tit4"
        >
          <div class="not-continuous-w">
            <span>PDF会员{{ pdfPermissionVipInfo.vip_ex_date | dateFilter }}到期</span>
            <a
              @click="showPay(0)"
              class="renew_btn nondraggable webkit-no-drag"
            >续费VIP</a>
          </div>
        </div>
        <!-- 非会员 -->
        <span
          v-else
          class="tit3 tit3-not-member"
        >升级为会员，享受高级特权</span>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import client from '@/client'
import * as deviceApi from '@/api/device'
import { DOMAIN_RELATED, LOGIN_SERVICE, URL_LIST, UNFINISH_PAY_LIST } from '@/config/dataMap'
import { getUnpaidGuideInfo, removeUnpaidGuideInfo } from '@/utils/sessionStorage'
export default {
  name: 'UserInfo',
  data () {
    return {
      showLogout: false,
      devicePixelRatio: window.devicePixelRatio,
      device_list: []
    }
  },
  computed: {
    ...mapGetters([
      'token',
      'userInfo',
      'pdfPermissionVipInfo',
      'loginStatus',
      'isMember',
      'isPdfMember',
      'openId',
      'avatar',
      'isPdfLifeMember'
    ]),
    memberShow () {
      return this.isMember && this.loginStatus
    },
    is_continuous () {
      return this.userInfo && this.userInfo.is_continuous == 1
    },
    is_diamond () {
      return this.userInfo && this.userInfo.vip_type == 3
    },
    badgeClass () {
      if (this.is_diamond) {
        return 'sprite-icon sprite-icon-badge-diamond'
      }
      if (this.isMember) {
        return 'sprite-icon sprite-icon-badge-vip'
      }
      if (this.isPdfMember || this.isPdfLifeMember) {
        return 'sprite-icon sprite-icon-pdf-vip'
      }
      return ''
    }
  },
  watch: {
    isMember (val) {
      if (val) {
        this.getDeviceList()
      }
    }
  },
  /* eslint-disable-next-line */
  async mounted () {
    if (this.loginStatus) {
      this.refresh({ token: this.token, open_id: this.openId, webRefresh: 1 })
    }
    this.getDeviceList()
    this.$EventBus.$on('loginSuccess', () => this.getDeviceList())
    this.$EventBus.$on('triggerLogin', () => this.login(2))
  },
  methods: {
    /* eslint-disable-next-line */
    login (type) {
      if (this.loginStatus) {
        return false
      }
      client.common.API.userLogin({ url: LOGIN_SERVICE.url })
      if (type) {
        client.home.REPORT.reportHomeOperate({
          main_click: type,
          user_login: this.loginStatus ? 1 : 2
        })
      }
    },
    ...mapActions('user', ['setLoginStatus', 'refresh']),
    logout (op) {
      this.setLoginStatus(0)
      op && client.common.API.exit()
      this.$EventBus.$emit('logout') // 触发事件
      if (op == 2) {
        client.home.REPORT.reportHomeOperate({
          main_click: 3,
          user_login: this.loginStatus ? 1 : 2
        })
      }

      // 退出账号，如果未支付引导状态是1，则清除
      try {
        if (getUnpaidGuideInfo() === UNFINISH_PAY_LIST.HAVE_SCAN_QRCODE) {
          removeUnpaidGuideInfo()
        }
      } catch (e) {
        console.log(e)
      }
    },
    changeShowLogout (bool, timout) {
      setTimeout(() => {
        this.showLogout = bool
      }, timout)
    },
    showPay (tab) {
      client.home.REPORT.reportHomeOperate({
        main_click: 11,
        user_login: this.loginStatus ? 1 : 2
      })
      if (!tab) {
        client.common.API.client_openOptionWindow({
          url: `${DOMAIN_RELATED.domain}${DOMAIN_RELATED.channel}/renewal`,
          width: 688,
          height: 490,
          open_opction: 19,
        })
      } else {
        this.$emit('showPay')
        this.$EventBus.$emit('showPay', tab)
      }
    },
    toDeviceAdmin () {
      client.home.REPORT.reportHomeOperate({
        main_click: 55,
        user_login: this.loginStatus ? 1 : 2
      })
      client.device.API.openDeviceAdmin({ token: this.token, open_id: this.openId, sfrom: 1 })
    },
    async getDeviceList () {
      if (this.loginStatus) {
        const res = await deviceApi.getDeviceList()
        this.device_list = res.device_list || []
      }
    },
    /* eslint-disable-next-line */
    async changeUserInfo () {
      if (!this.loginStatus) {
        this.login(1)
        return
      }
      client.home.REPORT.reportHomeOperate({
        main_click: 56,
        user_login: this.loginStatus ? 1 : 2
      })
      // if (await ClientCompatible.checkModifyUserInfoVersion()) {
      this.$emit('showChangeUserInfoPop')
      // }
    }
  },

}
</script>

<style scoped lang="scss">
@import '@/assets/css/mixins.scss';
@mixin btn_common_class{
  display: inline-block;
  background: #de461e;
  color: #fff;
  height: 23px;
  line-height: 23px;
  font-size: 12px;
  text-align: center;
  border-radius: 10px;
  margin-left: 14px;
  box-sizing: border-box;
  cursor: pointer;
  &:hover {
    background: #f6613a;
    border-color: #f6613a;
    color: #fff;
  }
}
.userinfo {
.position-div {
  position: absolute;
  display: inline-block;
}
position: relative;
height: 120px;
font-size: 14px;
background: url(~@/assets/images/not-member-bg.png) no-repeat center center;
  z-index: 0;
  padding-top: 40px;
  box-sizing: border-box;
  .section {
    height: 80px;
  }
  .avatar-wrap {
    cursor: pointer;
  }
  .not-login-avatar,
  .avatar {
    position: absolute;
    top: 35px;
    left: 24px;
    width: 72px;
    height: 72px;
    border-radius: 50%;
  }
  .logo {
    display: flex;
    align-items: center;
    height: 18px;
    line-height: 18px;
    position: absolute;
    left: 8px;
    top: 8px;
    z-index: 1;
    color: #b07400;
    font-size: 12px;
    .sprite-icon-home-logo {
      margin-right: 5px;
    }
  }
  .pointer {
    cursor: pointer;
  }
  .user-icon {
    position: absolute;
    bottom: 0;
    left: 64px;
    width: 49px;
    height: 51px;
  }
  .user-name-w {
    font-size: 18px;
    color: #732d0a;
    top: 40px;
    left: 130px;
    position: absolute;
    display: flex;
    align-items: center;
    line-height: 20px;
    span {
      display: inline-block;
      font-weight: bold;
    }
    .btn {
      height: 20px;
      border-radius: 4px;
      border: 1px solid #b07400;
      font-size: 12px;
      color: #b07400;
      padding: 0 6px;
      margin-left: 8px;
      cursor: pointer;
      text-align: center;
      background: #ffefae;
      &:hover {
        background-color: #fffbe3;
      }
      &:active {
        background-color: #efdea9;
      }
    }
  }
  .tit1 {
    color: #9c7008;
    top: 40px;
    left: 123px;
    font-weight: 500;
    line-height: 1;
  }
  .tit3,
  .tit4 {
    position: absolute;
    color: #94fbff;
    top: 67px;
    left: 130px;
  }
  .tit4 {
    color: #b07400;
  }

  .tit3-not-member {
    color: #b07400;
  }

  .btn_login {
    top: 66px;
    left: 123px;
    width: 96px;
    height: 30px;
    line-height: 30px;
    background: #dc320a;
    color: #fff;
    border-radius: 15px;
    text-align: center;
    cursor: pointer;
    &:hover {
      background: #ff390b;
    }
    &:active {
      background: #c42c08;
    }
  }
  .not-continuous-w {
    display: flex;
    align-items: center;
    line-height: 20px;
  }

  .renew_btn {
    width: 76px;
    @include btn_common_class;
  }
  .upgrade_btn {
    width: 50px;
    @include btn_common_class;
  }

  .coin-num {
    position: absolute;
    left: 130px;
    top: 93px;
    font-size: 12px;
    color: #b07400;
    line-height: 16px;
    display: flex;
    align-items: center;

    .coin {
      color: #ea4216;
    }
    .red-color {
      color: #ff0000;
    }
    .coin-member-tip {
      height: 16px;
      border-radius: 2px;
      line-height: 16px;
      font-size: 12px;
      display: inline-block;
      margin-left: 13px;
      vertical-align: bottom;
      text-align: center;
      display: flex;
      align-items: center;
    }
  }
}
.nondraggable {
  -webkit-app-region: no-drag;
}
</style>
